import { View } from "./View";

export const OverflowMenuDropDown = (props: {
  navigateToEdit: () => void;
  openDeleteModal: () => void;
}) => {
  return <View {...props} />;
};
